import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import styles from './ManagementList.scss';

import ManagementListContent from './ManagementListContent';
import ManagementListTitle from './ManagementListTitle';
import ManagementListText from './ManagementListText';
import ManagementListButton from './ManagementListButton';

function ManagementListRow(props) {
    return (<div className={styles['ml-row']} data-list={props.name}>
        <ManagementListContent>
            <ManagementListTitle>
                {props.title}
            </ManagementListTitle>
            <ManagementListText>
                {props.description}
            </ManagementListText>
        </ManagementListContent>
        <ManagementListButton {...props} />
    </div>)
}

ManagementListRow.displayName = displayName('ManagementList/ManagementListRow');

ManagementListRow.propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.node.isRequired,
    description: PropTypes.node,
};

ManagementListRow.defaultProps = {
    description: null,
};

export default ManagementListRow;
